import {LoginActions} from '../actions';

import {config} from '@core/common/constants/config';

import {createReducer, on} from '@ngrx/store';
import {AuthState, LoginReq, RegisterReq,} from '@app/core/models';

export interface LoginState {
  authorization: AuthState;
  loginProcess: string;
  loginError: any;
  guestToken?: string;
  requester?: LoginReq | RegisterReq | any;
}
export const LOGIN_INITIAL_STATE: LoginState = {
  authorization: {
    token: undefined,
    Customer: undefined,
    type: 5,
    status: false,
    exp: 0,
  },
  loginProcess: '',
  loginError: undefined,
};

export const loginReducer = createReducer(
  LOGIN_INITIAL_STATE,
  // Login
  on(LoginActions.login, (state, { payload }) => {
    return {
      ...state,
      loginProcess: 'Process login',
      requester: { ...payload, password: '' },
    };
  }),
  on(LoginActions.loginSocial, (state, { payload }) => {
    return {
      ...state,
      loginProcess: 'Process Social login',
    };
  }),
  on(LoginActions.loginSuccess, (state, { payload }) => {
    if (
      !payload ||
      !payload.Result.StatusCode ||
      payload.Result.StatusCode.toString() != config.RESPONSE_CODE_SUCCESS
    ) {
      return state;
    }

    const author: AuthState = {
      token:
        payload.Customer.UserType === 5 ? undefined : payload.Customer.Token,
      type: payload.Customer.UserType,
      status: payload.Customer.IsActive,
      exp: 1,
      Customer: payload.Customer,
    };

    return {
      ...state,
      authorization: author,
      guestToken:
        payload.Customer.UserType === 5
          ? payload.Customer.Token
          : state.guestToken,
      loginProcess: 'Login success',
      loginError: null,
    };
  }),
  on(LoginActions.loginError, (state, { payload }) => ({
    ...state,
    loginError: payload,
    loginProcess: 'Login failed',
  })),
  // Guest
  on(LoginActions.backToGuest, (state, { payload }) => {
    return {
      ...state,
      loginProcess: 'back to guest',
      authorization: {
        ...state.authorization,
        status: false,
        type: 5,
        token: undefined,
      },
    };
  }),
  // Register
  on(LoginActions.register, (state, { payload }) => {
    return {
      ...state,
      loginProcess: 'Process register',
      requester: { ...payload, password: '' },
    };
  }),
  on(LoginActions.registerSuccess, (state, { payload }) => {
    if (
      !payload ||
      !payload.Result.StatusCode ||
      payload.Result.StatusCode.toString() != config.RESPONSE_CODE_SUCCESS
    ) {
      return state;
    }

    const author: AuthState = {
      token: payload.Token,
      type: payload.Customer?.UserType ?? 0,
      status: payload.Customer?.IsActive,
      exp: 1,
      Customer: payload.Customer,
    };

    return {
      ...state,
      authorization: author,
      loginProcess: 'register success',
      loginError: null,
    };
  }),
  on(LoginActions.registerError, (state, { payload }) => ({
    ...state,
    loginError: payload,
    loginProcess: 'register failed',
  })),

  // Activation Code - Verify
  on(LoginActions.verificationCode, (state, { payload }) => {
    return {
      ...state,
      loginProcess: 'verify code',
    };
  }),
  on(LoginActions.verificationCodeSuccess, (state, { payload }) => {
    if (
      !payload ||
      !payload.Result?.StatusCode ||
      payload.Result?.StatusCode.toString() != config.RESPONSE_CODE_SUCCESS
    ) {
      return state;
    }

    const author: AuthState = {
      token: payload.Customer.Token,
      type: payload.Customer.UserType,
      status: payload.Customer.IsActive,
      exp: 1,
      Customer: payload.Customer,
    };

    return {
      ...state,
      authorization: author,
      loginProcess: 'register success',
      loginError: null,
    };
  }),
  on(LoginActions.verificationCodeFail, (state, { payload }) => ({
    ...state,
    loginError: payload,
    loginProcess: 'verify code  failed',
  })),

  // Activation Code - Resend
  on(LoginActions.resendActivationCode, (state, { payload }) => {
    return {
      ...state,
      loginProcess: 'resend verify code',
    };
  }),
  on(LoginActions.resendActivationCodeSuccess, (state, { payload }) => {
    if (
      !payload ||
      !payload.Result?.StatusCode ||
      payload.Result?.StatusCode.toString() != config.RESPONSE_CODE_SUCCESS
    ) {
      return state;
    }

    const author: AuthState = {
      token: payload.Token,
      type: payload.Customer.UserType,
      status: payload.Customer.IsActive,
      exp: 1,
      Customer: payload.Customer,
    };

    return {
      ...state,
      authorization: author,
      loginProcess: 'register success',
      loginError: null,
    };
  }),
  on(LoginActions.resendActivationCodeFail, (state, { payload }) => ({
    ...state,
    loginError: payload,
    loginProcess: 'resend verify code  failed',
  })),

  // Forget password
  on(LoginActions.forgetPassword, (state, { payload }) => {
    return {
      ...state,
      loginProcess: 'forget password',
      requester: {
        ...state.requester,
        email: payload.key,
        phoneNumber: payload.key,
        phoneCode: payload.mobileCode,
        useEmail: payload.useEmail,
      },
    };
  }),
  on(LoginActions.forgetPasswordSuccess, (state, { payload }) => ({
    ...state,
    authorization: { ...state.authorization, token: payload.Token },
    loginProcess: 'forget password success',
  })),
  on(LoginActions.forgetPasswordFail, (state, { payload }) => ({
    ...state,
    loginProcess: 'forget password error',
  })),
  // Store Profile
  on(LoginActions.StoreProfile, (state, { payload }) => ({
    ...state,
    authorization: { ...state.authorization, Customer: payload },
    loginProcess: 'save profile',
  }))
);
